var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-nav'),_vm._v(" "),_c('h1',[_vm._v("汇通")]),_vm._v(" "),_c('v-footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }